import { Container, Row, Col } from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";

export default function GetHomeSafeFooter({
    customClass = "",
  }) {
    return (
      <section className={`${styles.root} ${customClass} mt-4`}>
        <Container>
  
          <div className="cta-banner w-100 text-center p-4">
            <p className="mb-0 text-white">
              If you're ever unsure or worried about your journey, please speak to{" "}
              <Link href="/job-seekers-get-in-touch">
                <a className="cta-link">gap personnel</a>
              </Link>.
            </p>
          </div>
  
          <div className="disclaimer-box mt-4 p-3">
            <p className="mb-0">
              Our Get Home Safe initiative provides guidance, information, and practical support to help workers make informed decisions about their commute. While we promote safer travel wherever possible, we cannot guarantee individual safety or control factors such as public transport, travel routes, or personal arrangements. We provide this information as supportive guidance only and encourage workers to always check details before travelling, as schedules and services can change at short notice.
            </p>
          </div>
  
        </Container>
      </section>
    );
  }